import qs from 'qs';
import axiosClient from './axiosClient';
import { serviceBase } from './serviceBase';

export const getFiscalInterestBalanceList = serviceBase({
  request: options =>
    axiosClient.get('/accounting/fiscal-interest-balance', {
      params: options,
      paramsSerializer: params => {
        return qs.stringify(params, { arrayFormat: 'repeat' });
      }
    }),
  retry: 0
});

export const downloadExportedFiscalInterestBalance = serviceBase({
  request: options =>
    axiosClient.get('/accounting/fiscal-interest-balance/export', {
      responseType: 'blob',
      params: options,
      timeout: 120000
    }),
  transformResponse: res => {
    try {
      const filename = 'Balance de intereses.xlsx';
      const a = document.createElement('a');
      a.href = window.URL.createObjectURL(res.data);
      a.download = filename;
      a.style.display = 'none';
      document.body.appendChild(a);
      a.click();
    } catch (error) {
      console.log(`Opps, un error: ${error}`);
      console.error(error);
    }
  },
  retry: 0
});

export const getAccountingInterestBalanceList = serviceBase({
  request: options =>
    axiosClient.get('/accounting/accounting-interest-balance', {
      params: options,
      paramsSerializer: params => {
        return qs.stringify(params, { arrayFormat: 'repeat' });
      }
    }),
  retry: 0
});

export const downloadAccountingInterestBalance = serviceBase({
  request: options =>
    axiosClient.get('/accounting/accounting-interest-balance/export', {
      responseType: 'blob',
      params: options,
      timeout: 120000
    }),
  transformResponse: res => {
    try {
      const filename = 'Balance contable de intereses.xlsx';
      const a = document.createElement('a');
      a.href = window.URL.createObjectURL(res.data);
      a.download = filename;
      a.style.display = 'none';
      document.body.appendChild(a);
      a.click();
    } catch (error) {
      console.log(`Opps, un error: ${error}`);
      console.error(error);
    }
  },
  retry: 0
});
